export default "__VITE_ASSET__BDytMi$D__"